export default function ComparisonTable() {
  return (
    <section id="comparison" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-4">
            Why Users Prefer VigorBuy Spreadsheet
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            See how our organized research approach compares to traditional product searching across the web.
          </p>
        </div>

        <div className="max-w-3xl mx-auto overflow-hidden rounded-2xl border border-background-200/70 bg-background-50">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-background-200/70">
                  <th className="text-left px-6 py-5 font-heading font-semibold text-sm text-foreground-900">
                    Feature
                  </th>
                  <th className="text-center px-6 py-5 font-heading font-semibold text-sm text-primary-700 bg-primary-50/50">
                    <div className="flex items-center justify-center gap-2">
                      <i className="ri-file-list-3-line text-primary-500"></i>
                      VigorBuy Spreadsheet
                    </div>
                  </th>
                  <th className="text-center px-6 py-5 font-heading font-semibold text-sm text-foreground-700">
                    Traditional Search
                  </th>
                </tr>
              </thead>
              <tbody>
                {[
                  { feature: 'Organization', v: 'Structured Lists', t: 'Scattered Information', vIcon: 'ri-check-line', tIcon: 'ri-close-line' },
                  { feature: 'Research Speed', v: 'Fast', t: 'Slow', vIcon: 'ri-check-line', tIcon: 'ri-close-line' },
                  { feature: 'Comparison', v: 'Easy', t: 'Difficult', vIcon: 'ri-check-line', tIcon: 'ri-close-line' },
                  { feature: 'Beginner Friendly', v: 'Yes', t: 'Limited', vIcon: 'ri-check-line', tIcon: 'ri-close-line' },
                  { feature: 'Category Navigation', v: 'Advanced', t: 'Basic', vIcon: 'ri-check-line', tIcon: 'ri-close-line' },
                ].map((row, idx) => (
                  <tr key={row.feature} className={`border-b border-background-200/60 ${idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}>
                    <td className="px-6 py-4 text-sm font-medium text-foreground-800">{row.feature}</td>
                    <td className="px-6 py-4 text-center bg-primary-50/30">
                      <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-700">
                        <i className={`${row.vIcon} text-primary-500 text-xs`}></i>
                        {row.v}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <span className="inline-flex items-center gap-1.5 text-sm text-foreground-500">
                        <i className={`${row.tIcon} text-foreground-400 text-xs`}></i>
                        {row.t}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}